import React from "react";
import { Link } from "gatsby";

import { EuiText, EuiCallOut } from "@elastic/eui";

function PrimaryBox() {
  return (
    <EuiCallOut size="m" iconType="gear" title="Beachten Sie bitte">
      <EuiText>
        <p>
          There is a{" "}
          <Link to="/Frequently_Asked_Question/WQHD_MQTTv5_Alarmserver_Testing/">
            new alarm server API for WQHD 2K+ cameras
          </Link>
          . The individual steps below are still valid. Only the URL query is
          now called <code>&trigger</code> instead of <code>&active</code>, the
          numerical values have changed and now allow the evaluation of
          multiple, simultaneous alarm triggers! You will find an example
          implementation of the MQTT and HTTP alarm server v2 API with Node-RED{" "}
          <Link to="/Frequently_Asked_Question/WQHD_MQTTv5_Alarmserver_APIv2_NodeRED/">
            here
          </Link>
          .
        </p>
      </EuiText>
    </EuiCallOut>
  );
}

export default PrimaryBox;
